import { render, staticRenderFns } from "./KeratoscopyView.vue?vue&type=template&id=1ec2d79e"
import script from "./KeratoscopyView.vue?vue&type=script&lang=js"
export * from "./KeratoscopyView.vue?vue&type=script&lang=js"
import style0 from "./KeratoscopyView.vue?vue&type=style&index=0&id=1ec2d79e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports